<div class="color-picker-container">
  <form [formGroup]="colorForm">
    <mat-form-field>
      <input matInput
             [formControlName]="formName"
             [ngxMatColorPicker]="picker"
             [disabled]="disabled"
             placeholder="{{ 'pages.config-all.config-colour.heading' | translate }}"
             (colorChange)="onColorChange($event)">
      
      <ngx-mat-color-toggle matSuffix 
                           [for]="picker"
                           [disabled]="disabled">
      </ngx-mat-color-toggle>
      
      <ngx-mat-color-picker #picker 
                           [touchUi]="touchUi"
                           [color]="defaultColor">
      </ngx-mat-color-picker>

      <mat-error *ngIf="colorControl?.errors?.['required']">
        {{ 'pages.config-all.config-colour.required' | translate }}
      </mat-error>
      <mat-error *ngIf="colorControl?.errors?.['pattern']">
        {{ 'pages.config-all.config-colour.invalid' | translate }}
      </mat-error>
    </mat-form-field>
  </form>
</div>
